import React, { Component } from 'react';
import Sec1 from './Section/Sec1';
import './App.css';

class App extends Component {
  render() {
    return (
      <div>
        <Sec1/>
      </div>
    );
  }
}

export default App;
